"use client";

import { useEffect, useState, useRef } from "react";
import { getBanner } from "@/lib/graphQLRequest";
import { SkeletonBanner } from "./SkeletonBanner";
import { useAutoAnimate } from '@formkit/auto-animate/react'
import Banner from "./Marquee";

const MostrarBanner = () => {
  const [bannerData, setBannerData] = useState([]);
  const [loading, setLoading] = useState(true);
  const referencia = useRef();
  const [parent, enableAnimations] = useAutoAnimate()
  

  useEffect(() => {
    const fetchData = async () => {
      try {
        const banner = await getBanner();
        setBannerData(banner[2].node.banner);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching banner data:", error);
        setLoading(false); // Si hay un error, también debes establecer loading en false
      }
    };
    fetchData();
  }, []);

  const ocultar = (e) => {
    referencia.current.style.visibility = "hidden";
  };


  return (
    <div ref={referencia} className="bg-[#111] text-white border-b-[1px] border-white">
      <div ref={parent}>
          {loading ? (
            <SkeletonBanner />
          ) : (
            <div>
              <div className="lg:hidden banner-marquee text-black relative h-[24px] flex justify-between items-center overflow-x-hidden motion-safe:overflow-x-hidden pause-animations-on-children-on-hover bg-gray-50">
                <div className="w-[28%] flex justify-end">

                </div>
                <div className="lg:w-[90%] overflow-x-hidden relative mostrar-marquee-banner-home">
                  <div className="animate-marquee whitespace-nowrap motion-safe:animate:marquee">
                    <span className="flex items-center text-[14px] mx-4">
                      <p className="block text-sm leading-6 text-gray-900">
                        <strong className="font-semibold">DESCUENTO</strong> • 15% off en todos los accesorios, cupón: #minca15
                      </p>
                    </span>
                    <span className="text-[14px] mx-4">
                    LANZAMIENTO • Nueva Minca 2400W, ¡Aprovecha descuento!
                    </span>
                    <span className="flex items-center text-[14px] mx-4">
                      <p className="block text-sm leading-6 text-gray-900">
                        <strong className="font-semibold">DESCUENTO</strong> • 15% off en todos los accesorios, cupón: #minca15
                      </p>
                    </span>
                    <span className="text-[14px] mx-4">
                    LANZAMIENTO • Nueva Minca 2400W, ¡Aprovecha descuento!
                    </span>
                    <span className="flex items-center text-[14px] mx-4">
                      <p className="block text-sm leading-6 text-gray-900">
                        <strong className="font-semibold">DESCUENTO</strong> • 15% off en todos los accesorios, cupón: #minca15
                      </p>
                    </span>
                  </div>
                </div>
                <div className="w-[28%] flex justify-end">
                </div>
              </div>
              <div className="hidden lg:block">
                <Banner marquee={bannerData} ocultar={ocultar} />
              </div>
            </div>
          )}
      </div>
    </div>
  );
};

export default MostrarBanner;